import * as Builder from '../shared/Builder';

export default function AdBuilderController(
  CreativeService,
  CurrentUserService,
  OpenGraphDataService,
  RenderService,
  SaveCreativeService,
  SettingsService
) {
  const vm = this;

  let saving = false;

  vm.ogDataService = OpenGraphDataService;
  vm.savePreview = savePreview;
  vm.userSignedIn = false;
  vm.validYoutube = true;
  vm.creativeService = CreativeService;
  vm.validateYoutubeUrl = validateYoutubeUrl;
  SettingsService.showBuilderHeader = true;
  vm.getScreenSize = () => RenderService.siteGroup;
  vm.builderType = Builder.choose(CreativeService.creative);

  vm.MAX_HEADLINE_LENGTH = 90;
  vm.MAX_DESCRIPTION_LENGTH = 200;

  if (RenderService.site.isExternalDemo) {
    SettingsService.showBuilderHeader = false;
  }

  CurrentUserService.get().then(user => {
    vm.userSignedIn = !!user;
  });

  function validateYoutubeUrl() {
    if (CreativeService.creative.mediaUrl) {
      const isYoutube = CreativeService.creative.mediaUrl.match(
        /(?:www\.)?youtube.com|youtu.be/
      );

      if (!isYoutube) {
        vm.validYoutube = false;
        return;
      }
    }

    vm.validYoutube = true;
  }

  function savePreview() {
    if (saving) {
      return;
    }

    saving = true;

    return SaveCreativeService.save(CreativeService.creative).finally(() => {
      saving = false;
    });
  }

  return vm;
}

AdBuilderController.$inject = [
  'CreativeService',
  'CurrentUserService',
  'OpenGraphDataService',
  'RenderService',
  'SaveCreativeService',
  'SettingsService'
];
